export { belongsTo, hasMany } from '@ember-data/model';